module.exports ={
    help_center: 'Help center',
    go_to: 'Return UPlus',
}
